<template>
  <transition name="slide-fade">
    <v-container fluid class="p-header">
      <v-layout wrap class="mb-10">
        <v-flex xs12 order-xs2 order-sm1 order-md3 order-lg3 class="hidden-md hidden-lg">
          <div class="layout wrap justify-center my-1 align-center logo-header">
            <v-img lazy-src="/images/placeholder.gif" src="/images/full_logo.png" width="40vw" class="p-image"></v-img>
          </div>
        </v-flex>
        <v-flex xs12 order-xs3 order-sm3 order-md1 order-lg1 class="intro-text my-1">
          <p class="text-center" v-html="$default_settings['system description']"></p>
            <!-- <p class="text-center">PrimacyHealth is the platform provided by Primacy Aid Healthcare to enable end users easy access to medical services.</p> -->
            <!-- <p class="text-center">‘Primacy health’ allows both the client and the service provider to access and provide the medical service.</p> -->
          </v-flex>
        <v-flex xs12 order-xs1 order-sm2 order-md2 order-lg2 id="home">
          <create-service-request :packages="packages" :insurance_providers="insurance_providers" :coupon="coupon"></create-service-request>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/Guest'
  import CreateServiceRequest from '@/Components/ServiceRequest/create'
  // const CreateServiceRequest = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "service-requests" */ '@/Components/ServiceRequest/create')

  export default {
    name: 'CreateServiceRequests',
    layout,
    props: [
      'packages',
      'insurance_providers',
      'coupon'
    ],
    components: {
      CreateServiceRequest,
    },
    metaInfo () {
      return {
        title: 'Request Services',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    mounted () {
      this.$nextTick(() => {
        let vm = this
        setTimeout(() => {
          var home = document.getElementById('home')
          vm.$vuetify.goTo(home, { offset: 0 })
        }, 2500);
      })
    }
  }
</script>

<style scoped>
  .p-header {
    background: url(/images/tablets.jpg) rgba(52,111,59,0.9);
    background-size: cover;
    background-attachment: fixed;
    background-blend-mode: color-burn;
  }
  .intro-text {
    background: #9800cb;
    font-size: x-large;
    border-radius: 20px;
  }
  .logo-header {
    background: rgba(255,255,255,0.7);
    border-radius: 20px;
  }
</style>
